<h3>Az alap adatok módosításához írja be az AUSZ kódját!</h3>
<form class="p-3">
  <input class="form-control" [formControl]="auszControl"/>
  <label *ngIf="errorMessage" class="mt-2 errorMessage">{{errorMessage}}</label>
  <div class="d-flex w-100 justify-content-center mt-2">
    <button class="btn btn-primary mr-2" (click)="checkUserAusz()">Rendben</button>
    <button class="btn btn-danger ms-auto" mat-dialog-close>Mégse</button>
  </div>
</form>
